module.exports = __webpack_public_path__ + "img/jomatik_logo.20d0ce95.jpg";